import { Component, OnInit }  from '@angular/core';
import { TranslateService }   from '@ngx-translate/core';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

import { ActivationStatusModel }  from './typings/workshop-web.activation-status';
import { CodeTypeModel }          from '../core/models/code-type';
import { ConfirmService }         from '../messages/confirm/confirm.service';
import { MessagesService }        from '../messages/messages.service';
import { WorkshopWebService }     from './workshop-web.service';
import { WorkshopWebStatusModel } from './typings/workshop-web.status';

@Component({
  selector   : 'wor-workshop-web-settings',
  template: require('./workshop-web.settings.component.html')
})
export class WorkshopWebSettingsComponent implements OnInit {
  @BlockUI('workshopWebSettingsBlock') block : NgBlockUI;

  status : ActivationStatusModel;
  type   : string;
  types  : Array<CodeTypeModel> = [];
  url    : string;

  constructor (
    private confirmService     : ConfirmService,
    private messagesService    : MessagesService,
    private translateService   : TranslateService,
    private workshopWebService : WorkshopWebService
  ) {}

  ngOnInit () : void {
    this.block.start();

    this.workshopWebService.getStatus()
    .then(( status : WorkshopWebStatusModel ) => {
      this.status = status.status;
      this.url    = status.workshop_url;

      return this.workshopWebService.getWorkshopTypes();
    })
    .then(( types : Array<CodeTypeModel> ) => {
      this.type  = types[ 0 ]?.code;
      this.types = types;
    })
    .catch(err => this.messagesService.error(err))
    .finally(() => this.block.stop());
  }

  activate () : void {
    this.confirmService.custom({
      message: this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.WORKSHOP_WEB.ACTIVATE_CONFIRMATION'),
      buttons: {
        confirm: {
          class: 'success',
          title: this.translateService.instant('GENERAL_SPACE.BUTTON.ACTIVATE')
        }
      }
    })
    .then(() => {
      this.block.start();

      return this.workshopWebService.activate(this.type);
    })
    .then(( response ) => {
      this.status      = 'publish';
      this.url = response.workshop_url;

      this.messagesService.show(this.translateService.instant('JS_SPACE.INTEGRATIONS.ACTIVATED', {
        name: this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.WORKSHOP_WEB.WORKSHOP_WEB')
      }), 'success');
    })
    .catch(err => this.messagesService.error(err))
    .finally(() => this.block.stop());
  }

  deactivate () : void {
    this.confirmService.custom({
      message: this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.WORKSHOP_WEB.DEACTIVATE_CONFIRMATION'),
      buttons: {
        confirm: {
          class: 'danger',
          title: this.translateService.instant('GENERAL_SPACE.BUTTON.DEACTIVATE')
        }
      }
    })
    .then(() => {
      this.block.start();

      return this.workshopWebService.deactivate();
    })
    .then(() => {
      this.status = 'draft';

      this.messagesService.show(this.translateService.instant('JS_SPACE.INTEGRATIONS.DEACTIVATED', {
        name: this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.WORKSHOP_WEB.WORKSHOP_WEB')
      }), 'success');
    })
    .catch(err => this.messagesService.error(err))
    .finally(() => this.block.stop());
  }

  isStatus ( status : ActivationStatusModel ) : boolean {
    return this.status === status;
  }

  reactivate () : void {
    this.confirmService.custom({
      message: this.translateService.instant('JS_SPACE.INTEGRATIONS.REACTIVATE', {
        name: this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.WORKSHOP_WEB.WORKSHOP_WEB')
      }),
      buttons: {
        confirm: {
          class: 'success',
          title: this.translateService.instant('GENERAL_SPACE.BUTTON.REACTIVATE')
        }
      }
    })
    .then(() => {
      this.block.start();

      return this.workshopWebService.reactivate();
    })
    .then(( response ) => {
      this.status = 'publish';

      if ( response.workshop_url ) {
        this.url = response.workshop_url;
      }

      this.messagesService.show(this.translateService.instant('JS_SPACE.INTEGRATIONS.REACTIVATED', {
        name: this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.WORKSHOP_WEB.WORKSHOP_WEB')
      }), 'success');
    })
    .catch(err => this.messagesService.error(err))
    .finally(() => this.block.stop());
  }
}
